import React, { useState } from "react";
import { useSelector } from "react-redux";
import { PendingReturnListState } from "../../redux/state";
import { ItemTabs } from "./ItemTabs";
import { CollectionList } from "./Tabs/CollectionList";
import { Typography } from "@material-ui/core";
import { authSelector } from "../../redux/selectors";
import { UserType } from "@ofqual/portal-client-shell/dist/module/redux/state";
import { PreviousCollectionList } from "./Tabs/PreviousCollectionList";
import { Prompt } from "react-router-dom";
export const LookupList: React.FC<{
  state: PendingReturnListState;
}> = ({ state }) => {
  const items = state.response;
  const { userType } = useSelector(authSelector);
  const [loading, setLoading] = useState<any>();
  const [loaded, setLoaded] = useState<any>({});

  return (
    <>
      <Prompt
        message="An item is still being uploaded. Are you sure you want to navigate away from this page and lose these changes?"
        when={
          loading &&
          Object.keys(loading).find((x) => loading[x] < 100) !== undefined
            ? true
            : false
        }
      />
      {state.hasData ? (
        <ItemTabs>
          {(activeTab) =>
            activeTab === "current" ? (
              <CollectionList
                items={items}
                loading={loading}
                setLoading={setLoading}
                loaded={loaded}
                setLoaded={setLoaded}
              />
            ) : (
              <PreviousCollectionList />
            )
          }
        </ItemTabs>
      ) : userType === UserType.Ofqual ? (
        <Typography variant="h6" align="center">
          Select an organisation
        </Typography>
      ) : (
        <Typography variant="h6" align="center">
          No collections
        </Typography>
      )}
    </>
  );
};
